$(document).ready(function () {

    $(".FollowPop .RemoveIcon, .FollowItems .RemoveIcon, .GenGreen, .PrLike.active, .FollowItems .UnFollow").live("click", function () {
        var clickedItem = $(this);

        var Silid = $(this).attr("data-id");
        var colorid = $(this).attr("data-colorid");
        var gizlenecekSecim = $(this).closest("div");

        if ($(this).attr("data-followid").length > 0) {

            Silid = $(this).attr("data-followid");
            gizlenecekSecim = null;

            if ($(".HeartIcon").length > 0) {
                gizlenecekSecim = $(this).closest("div.SepetRow");
            }
        }

        var clickedIcon = $(this);
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).css("opacity", "0.5");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
            data: 'productID=' + Silid + '&colorID=' + colorid + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {
                    if ($(gizlenecekSecim).length > 0) {
                        $(gizlenecekSecim).hide("slow");
                    }
                    else {
                        $(clickedIcon).removeClass("GenGreen");
                        $(clickedIcon).val(dt.IslemSonucAciklama);
                        $('.LikeCount').html(dt.Deger4);
                        $(clickedItem).closest(".FollowListItem").slideUp();
                    }

                    //#region Related Datalayer Remove From Favorite Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion

                    $(clickedIcon).removeClass("active");
                    $(clickedIcon).addClass("add");
                    $("button.PrLike").text($("button.PrLike").attr("data-addtext"));

                    $HeartIcon = $(".HeartIcon");

                    if ($HeartIcon.length > 0) {

                        $HeartIconCountItem = $HeartIcon.find(".IconCount");
                        var IconCount = Number($HeartIconCountItem.text());

                        IconCount = IconCount - 1;

                        $HeartIconCountItem.text(IconCount);
                        if (IconCount <= 0) {

                            $HeartIconCountItem.addClass("gizli");
                        }

                        if ($(".HeartIcon div.SepetRow:visible").length - 1 <= 0) {
                            $HeartIcon.addClass("Blank");
                        }
                    }
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });
    });

    $("a.AjaxLink").live("click", function () {

        var callUrl = $(this).attr("href");
        var dynform = $(this).attr("data-dynform");

        $DynformDiv = $("div." + dynform + ":first");

        var dt = "";

        $.ajax({
            type: "GET",
            url: callUrl,
            success: function (data) {

                dt = data;
                $DynformDiv.html(data);


                // Adres formunda fatura bilgileri inputları için
                if ($("#AdresTipi2").is(":checked")) {
                    $(".vergi").show(); $(".tcno").hide();
                }

                if ($("#AdresTipi1").is(":checked")) {
                    $(".vergi").hide(); $(".tcno").show();
                }

                if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                    || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                    $(".tr_group").show();
                    $(".stateDiv").hide();
                    $(".cityDiv").hide();

                }

                if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                    $(".tr_group").hide();
                    $(".stateDiv").hide();
                    $(".cityDiv").show();

                }
                if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                    ||
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                    $(".tr_group").hide();
                    $(".stateDiv").show();
                    $(".cityDiv").show();

                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });



        return false;

    });

    $(".PassChange").live("click", function () {

        $.ajax({
            type: 'POST',
            url: '/' + $("#SmallLangCode").val() + '/p/User/ChangePass',
            data: $(".ChangePassForm").serialize(),
            success: function (dt) {
                $(".cp").html(dt);
            }
        });

        return false;

    });

    $("form.davetform").live("submit", function (e) {

        $form = $(this);

        $.ajax({
            type: $form.attr("method"),
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (data) {

                if ($('.validation-summary-errors').length) {

                    $('.validation-summary-errors')
                        .addClass('alert alert-error');
                }

                $(".AjaxLoader").hide();

                if (data.Sonuc != true) {

                    $form.find(".jsCreated").remove();
                    $form.prepend('<div class="validation-summary-errors alert alert-error jsCreated" data-valmsg-summary="true"><ul><li> ' + data.IslemSonucAciklama + ' </li></ul></div>');

                    return false;
                }
                else {

                    $form.find("div.jsCreated, .validation-summary-valid").remove();
                    $('<div class="validation-summary-valid alert alert-success jsCreated gizle" data-valmsg-summary="true"><ul><li> ' + data.IslemSonucAciklama + '</li></ul></div>').insertBefore($form).slideDown("slow");

                    $(".temizle").val('');


                }


            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        e.preventDefault;
        return false;

    });

    $("form.UserMessageForm").die("submit").live("submit", function () {

        $(".AjaxLoader").show();

        $.ajax({
            type: $(this).attr("method"),
            url: $(this).attr("action"),
            data: $(this).serialize(),
            cache: false,
            success: function (data) {

                $(".MessageBody").html(data);

                $(".AjaxLoader").hide();
            }
        });

        return false;

    });

    if (document.URL.indexOf("/p/User/") > -1 || document.URL.indexOf("/p/Orders/") > -1) {

        $(".grey .menuitem a").each(function (index) {

            var CurUrl = document.URL.split('/p/User/')[1];

            var CurLink = "";

            if (document.URL.indexOf("/p/Orders/") > -1) {

                CurUrl = document.URL.split('/p/Orders/')[1];
                CurLink = $("#SmallLangCode").val() + "/p/Orders/" + $("#AName").val();

            }
            else {
                CurLink = $("#SmallLangCode").val() + "/p/User/" + $("#AName").val();

            }

            if ($(this).attr("href").indexOf(CurLink) > 0) {

                if ($(this).attr("href").indexOf("hb=t") < 0) {
                    $(this).closest("li").addClass("current");

                }
                else if ($(this).attr("href").indexOf("hb=t") > 0 && document.URL.indexOf("hb=t") > -1) {
                    $(".grey li").removeClass("current");
                    $(this).closest("li").addClass("current");
                }
            }

        });

        $(".ToggleAccountMenu").html($(".menuitem.current:first").text() + "<span></span>");

        if ($(".menuitem.current:first").length <= 0) {
            $(".ToggleAccountMenu").html($(".menuitem:first").text() + "<span></span>");
        }
    }

    if ($(".HighlightLinkFromUrl").length > 0) {
        $(".HighlightLinkFromUrl a").each(function (index) {
            var CurLink = $("#CName").val() + "/" + $("#AName").val();
            if ($(this).attr("href").indexOf(CurLink) > 0) {
                $(this).addClass("active");
                $(this).parent().addClass("active");
            }
        });
    }

    // Siparişlerim sayfasında kargo takibi bilgilerini görmek için istek yapıp modal'ı ayarlayan event
    $("a.CargoDetailModal").live("click", function (event) {
        event.preventDefault();

        var clickedElement = $(this);
        var OrderModal = $("div#cargoTrackModel");
        var ModalTitle = $("h3.modal-title", OrderModal);
        var ModalContent = $("div.modal-body", OrderModal);

        var CurrentTitle = $(clickedElement).children("td:first").html();

        $(ModalTitle).html($("h3.ModalTitle").text());

        $.get(clickedElement.attr("data-trackFile"), function (data) {
            $(ModalContent).html(data);
        });
    });

    $("#sendConfirmMail").live("click", function () {

        $("#confirmMailModal").show()
        $("#confirmMailAddress").val($("#login_UserName").val());
    });
    $("#confimrMailBtn").live("click", function () {
        var email = $("#confirmMailAddress").val();
        if (email != undefined || email != "") {
            $.ajax({
                type: 'POST',
                url: '/' + $("#SmallLangCode").val() + '/p/User/SendConfirmMail?Email=' + email,
                success: function (dt) {
                    if (dt.Sonuc) {
                        $("#AlertResult").removeClass("alert-error");
                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").html(dt.IslemSonucAciklama)
                        $("#AlertResult").addClass("alert-success");
                        $("#AlertResult").addClass("alert");
                        $("#AlertResult").addClass("alert-block");

                        $("#confirmMailModal").hide()

                    } else {
                        $("#AlertResult").html(dt.IslemSonucAciklama)
                    }
                }
            });
        } else {

            $("#AlertResultConfModal").addClass("alert-error");
            $("#AlertResultConfModal").html("Lütfen Mail Adresi Giriniz!");
        }
    });
    $("#closeIcon").live("click", function () {
        $("#confirmMailModal").hide()

    });
    if ($("#localPassVM_User_Gsm").length > 0) {
        $("#localPassVM_User_Gsm").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(document).on("keyup", "#localPassVM_User_Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }
});